import type { RouteRecordRaw } from 'vue-router';

export const loginRoute: RouteRecordRaw = {
  path: '/login',
  name: 'Login',
  component: () => import('./pages/LoginPage.vue'),
  meta: {
    layout: 'empty',
    public: true,
  },
};

export const editMeRoute: RouteRecordRaw = {
  path: '/me/edit',
  name: 'EditMe',
  component: () => import('./pages/EditMePage.vue'),
  meta: {
    layout: 'main',
  },
};
